"use client";

import { usePopoverArrow } from "../__chunks/UPTSIFGR.js";
import "../__chunks/QFL5V2DO.js";
import { useTooltipContext } from "../__chunks/IEMWKLTV.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip-arrow.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "div";
var useTooltipArrow = createHook(function useTooltipArrow2(_a) {
  var _b = _a,
    store = _b.store,
    _b$size = _b.size,
    size = _b$size === void 0 ? 16 : _b$size,
    props = __objRest(_b, ["store", "size"]);
  var context = useTooltipContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component.");
  props = usePopoverArrow(__spreadValues({
    store: store,
    size: size
  }, props));
  return props;
});
var TooltipArrow = forwardRef(function TooltipArrow2(props) {
  var htmlProps = useTooltipArrow(props);
  return createElement(TagName, htmlProps);
});
export { TooltipArrow, useTooltipArrow };